// USAGE:
//
// import CopyText from "copy-text";
//
// . . .
//
// Base case (copy text from [data-copy] attribute of clicked element):
//
// CopyText();
//
//
// Extended case:
//
// CopyText().add({
//   trigger: "#my-trigger",
//   message: pie_i18n.PIE_JS_COPY_MESSAGE | undefined,
//   source: trigger => trigger.textContetn,
// });
//
// ⚠️ NOTE that "source" prop can be a function or a string.
//


export default function CopyText(root = document) {

  let triggers = [];
  let api = {};

  root.addEventListener("click", event => {

    if (event.target.matches("[data-copy]")) {
      navigator.clipboard.writeText(event.target.dataset.copy);
      alert(pie_i18n.PIE_JS_DATA_COPY_URL_COPIED + "😄👍");
    } else {
      for (const [trigger, source, message] of triggers) {
        if (event.target.matches(trigger)) {
          const textToCopy = typeof source === "function" ? source(event.target, event) : source;
          navigator.clipboard.writeText(textToCopy);
          message && alert(message + "😄👍");
          break;
        }
      }
    }
  });

  api.add = (config = {}) => {
    const { trigger, source, message = pie_i18n.PIE_JS_DATA_COPY_URL_COPIED } = config;
    triggers.push([trigger, source, message]);
    return api;
  }

  return api;

};